// Generated for @nava/participant-copy: Clair's default texts in Korean. Edit the texts here; the
// participant app's locale files are not read at runtime.
/** Clair's default texts in Korean. The texts that changed for Clair are translated without native review yet. */
export const PARTICIPANT_COPY_KO = {
    'landing.changeLanguage': '언어 변경',
    'common.language': '언어',
    // New for Clair, translated without native review yet.
    'common.talkInLanguages': 'Clair와 80개가 넘는 언어로 대화할 수 있습니다.',
    'common.seeLanguages': '언어 목록 보기',
    'footer.poweredBy': '제공:',
    'landing.heading': '짧은 대화에 초대되었습니다.',
    'landing.intro': '{company}에서 요즘 어떠신지 듣고 싶어 합니다. 편하신 때에 AI 어시스턴트 Clair와 대화하시게 됩니다.',
    'landing.continue': '계속',
    'preflight.title': '몇 가지만 확인할게요',
    'preflight.checkInSubtitle': '아래 항목을 완료하면 대화를 시작할 수 있습니다.',
    'preflight.actions.expandItem': '{{item}} 펼치기',
    'preflight.microphone.title': '마이크 접근',
    'preflight.microphone.checkInPrivacy': '음성은 AI 어시스턴트 Clair와의 대화에 사용됩니다. 대화는 녹음 및 기록되어 {company} 측에 공유됩니다. 모든 데이터는 암호화되어 안전하게 저장됩니다.',
    'preflight.microphone.readMore': '자세히 보기',
    'preflight.microphone.grantAccess': '접근 허용',
    'preflight.microphone.indicatorAction': '마이크 접근 허용',
    'preflight.microphone.accessGranted': '접근 허용됨',
    'preflight.microphone.errorHelper': '브라우저 설정을 확인하고 다시 시도해 주세요.',
    'preflight.microphone.browserNotSupported': '사용 중인 브라우저는 오디오 녹음을 지원하지 않습니다. Chrome, Firefox 또는 Safari를 사용해 주세요.',
    'preflight.terms.title': '개인정보 및 동의',
    'preflight.terms.checkInPrivacy': '이 대화는 {company}의 의뢰로 AI 어시스턴트 Clair가 진행합니다. 답변은 {company} 측에 공유되며 광고에는 절대 사용되지 않습니다. 언제든지 중단할 수 있습니다.',
    'preflight.terms.readMore': '자세히 보기',
    'preflight.terms.accept': '네, 동의합니다',
    'preflight.terms.indicatorAction': '개인정보 및 동의 수락',
    'preflight.terms.accepted': '동의함',
    'preflight.terms.rememberConsent': '30일 동안 내 동의 기억하기',
    'preflight.terms.rememberConsentCallTooltip': '동의는 이 통화에 대해서만 이 브라우저에 30일 동안 저장됩니다.',
    'quickStart.agree': '동의합니다',
    'quickStart.back': '뒤로',
    'quickStart.cancel': '취소',
    'preflight.startCheckIn': '대화 시작하기',
    'preflight.preparingCheckIn': '대화를 준비하고 있습니다...',
    'preflight.preparingCheckInDelayedTitle': '대화를 준비하고 있습니다.',
    'preflight.preparingCheckInDelayedSubtitle': '계속 작업 중입니다. 잠시만 기다려 주세요.',
    'preflight.preparingCheckInLongSubtitleLineOne': '예상보다 시간이 오래 걸리고 있습니다.',
    'preflight.preparingCheckInLongSubtitleLineTwo': '조금만 더 기다려 주세요.',
    'preflight.checkInPreparationFailedTitle': '대화를 준비하지 못했습니다',
    'preflight.checkInPreparationFailedMessage': '대화에 필요한 일부 파일을 불러오지 못했습니다. 연결 상태를 확인한 후 다시 시도해 주세요.',
    'preflight.retryPreparation': 'Try again',
    'interview.status.connecting': '연결 중',
    'interview.status.speaking': '말하는 중',
    'interview.status.listening': '듣는 중',
    'interview.status.thinking': '생각 중',
    'interview.question': '질문 {{current}}/{{total}}',
    'interview.mainQuestion': '주요 질문 {{current}}/{{total}}',
    'interview.recording': '답변이 녹음되고 있습니다...',
    'interview.endInterview': '대화 종료',
    'interview.muteTooltip': '마이크 끄기',
    'interview.unmuteTooltip': '마이크 켜기',
    'interview.pauseTooltip': '잠시 쉬기',
    'interview.resumeTooltip': '대화 다시 시작',
    'interview.subtitleTooltip.show': '자막 보이기 (CC)',
    'interview.subtitleTooltip.hide': '자막 숨기기 (CC)',
    'interview.toggleChat': '타이핑으로 전환',
    'interview.toggleVoice': '음성으로 전환',
    'interview.chatTooltip.type': '답변을 타이핑하기',
    'interview.chatTooltip.speak': '답변을 음성으로 말하기',
    'interview.chatTooltip.unavailable': '연결 후 사용 가능',
    'interview.chatDiscoveryHint': '말하기 어려우신가요? 탭하여 입력하세요',
    'interview.chatPlaceholder': '메시지를 입력하세요...',
    'interview.sendMessage': '보내기',
    'interview.chat.warmHeader': '천천히 입력하세요. 기다리고 있겠습니다',
    'interview.chat.newlineHint': 'Shift + Enter로 줄바꿈',
    'interview.chat.aiVoiceOn': '음성 켜기',
    'interview.chat.aiVoiceOff': '음성 끄기',
    'interview.chat.backToVoice': '음성으로 돌아가기',
    'interview.audio.controls': '오디오 설정',
    'interview.audio.callVolume': '통화 음량',
    'interview.audio.muteSpeaker': '스피커 음소거',
    'interview.audio.unmuteSpeaker': '스피커 음소거 해제',
    'interview.audio.microphone': '마이크',
    'interview.audio.speaker': '스피커',
    'interview.audio.device': '오디오 장치',
    'interview.audio.linkedRouting': '휴대전화에서 마이크와 스피커를 함께 제어합니다.',
    'interview.audio.phoneSpeaker': '휴대전화 스피커',
    'interview.audio.phoneEarpiece': '휴대전화 수화기',
    'interview.audio.bluetoothHeadset': '블루투스 헤드셋',
    'interview.audio.wiredHeadset': '유선 헤드셋',
    'interview.audio.usbAudio': 'USB 오디오',
    'interview.audio.systemDefault': '시스템 기본값',
    'interview.audio.changeFailed': '오디오 장치를 전환하지 못했습니다.',
    'interview.networkQuality.excellent': '네트워크 품질이 매우 좋습니다.',
    'interview.networkQuality.good': '네트워크 품질이 좋습니다.',
    'interview.networkQuality.poor': '네트워크 품질이 좋지 않습니다.',
    'interview.networkQuality.bad': '네트워크 품질이 매우 나쁩니다.',
    'interview.networkQuality.offline': '연결이 오프라인입니다.',
    'interview.pauseModal.title': '대화가 일시 중지되었습니다',
    'interview.pauseModal.timeRemaining': '{{time}} 남음',
    'interview.pauseModal.timeoutWarning': '일시 중지 상태가 계속되면 대화가 곧 자동으로 종료됩니다.',
    'interview.pauseModal.resume': '대화 다시 시작',
    'interview.pauseModal.end': '대화 종료',
    'interview.endConfirm.title': '대화를 종료할까요?',
    'interview.endConfirm.body': '종료 후에는 돌아올 수 없습니다. 지금까지의 진행 상황은 저장됩니다.',
    'interview.endConfirm.cancel': '대화 계속하기',
    'interview.endConfirm.end': '대화 종료',
    'complete.checkInTitle': '시간 내 주셔서 감사합니다',
    'complete.checkInMessage': '답변은 {company} 팀에 전달됩니다.',
    'studyClosed.checkInTitle': '이 대화는 종료되었습니다',
    'studyClosed.checkInMessage': '관심을 가져 주셔서 감사합니다. 이 대화는 더 이상 답변을 받지 않습니다.',
    'studyNotOpen.checkInTitle': '이 대화는 아직 열리지 않았습니다',
    'studyNotOpen.checkInMessage': '나중에 링크를 다시 열어 주세요.',
    'studyNotReady.checkInTitle': '대화가 곧 준비됩니다',
    'studyNotReady.checkInMessage': '몇 분 후에 링크를 다시 열어 주세요.',
    'participantLinkCompleted.checkInTitle': '이미 이 대화를 마치셨습니다',
    'participantLinkCompleted.checkInMessage': '시간 내 주셔서 감사합니다. 더 하실 일은 없습니다.',
    'loading.interview': '대화를 불러오는 중...',
    'browserHelp.title': '브라우저에서 열기',
    'browserHelp.description': '이 앱의 내장 브라우저는 마이크 접근을 제한할 수 있습니다. 원활한 이용을 위해 {{browserOptions}}에서 링크를 여세요.',
    'browserHelp.namedDescription': '{{app}}의 내장 브라우저는 마이크 접근을 제한할 수 있습니다. 원활한 이용을 위해 {{browserOptions}}에서 링크를 여세요.',
    'browserHelp.appleBrowsers': 'Safari 또는 Chrome',
    'browserHelp.windowsBrowsers': 'Microsoft Edge 또는 Chrome',
    'browserHelp.otherBrowsers': 'Chrome 또는 다른 브라우저',
    'browserHelp.openSafari': 'Safari에서 열기',
    'browserHelp.copyLink': '링크 복사',
    'browserHelp.copied': '링크가 복사되었습니다. 브라우저에 붙여넣으세요.',
    'browserHelp.manualCopy': '자동으로 복사하지 못했습니다. 아래 링크를 선택하여 복사하세요.',
    'browserHelp.copyInstructions': '아래 링크를 복사하여 다른 브라우저에 붙여넣으세요. 앱 메뉴에서 이 페이지를 기본 브라우저로 여는 옵션을 찾아볼 수도 있습니다.',
    'browserHelp.linkLabel': '대화 링크',
    'browserHelp.continueAnyway': '계속 진행',
    'preflight.microphone.recovery.denied': '마이크 접근이 거부되었습니다.',
    'preflight.microphone.recovery.timedOut': '마이크 액세스 요청 시간이 초과되었습니다. 브라우저에 권한 요청이 표시되는지 확인한 후 다시 시도하세요.',
    'preflight.microphone.recovery.notFound': '마이크를 찾을 수 없습니다. 마이크를 연결한 후 다시 시도해 주세요.',
    'preflight.microphone.recovery.notReadable': '마이크를 켤 수 없습니다. 마이크를 사용 중인 다른 앱을 닫고 다시 시도해 주세요.',
    'preflight.microphone.recovery.failed': '마이크에 접근할 수 없습니다. 마이크를 확인한 후 다시 시도해 주세요.',
    'preflight.microphone.recovery.retry': '다시 시도',
    'preflight.microphone.recovery.close': '닫기',
    'preflight.microphone.recovery.helpTitle': '마이크 접근 허용',
    'preflight.microphone.recovery.helpDescription': '마이크 접근이 여전히 차단되어 있습니다. 브라우저가 이전 선택을 기억하여 권한 요청을 다시 표시하지 않을 수 있습니다.',
    'preflight.microphone.recovery.safariMacSettings': 'Safari 메뉴 막대에서 Safari > 설정 > 웹사이트 > 마이크를 선택하세요. 목록에서 이 웹사이트를 찾으세요.',
    'preflight.microphone.recovery.chromiumSettings': '주소 표시줄 왼쪽의 사이트 제어 아이콘을 클릭한 다음 사이트 설정 > 마이크를 선택하세요.',
    'preflight.microphone.recovery.siteSettings': '주소창 옆의 아이콘이나 메뉴 또는 브라우저의 사이트 설정에서 이 웹사이트의 권한을 여세요.',
    'preflight.microphone.recovery.allowMicrophone': '이 웹사이트의 마이크 접근을 허용한 후 여기로 돌아와 “다시 시도”를 선택하세요. 브라우저에서 페이지를 새로고침하라고 요청하면 새로고침해 주세요.',
    'preflight.microphone.recovery.deviceSettings': '접근이 이미 허용되어 있다면 기기 설정에서 이 브라우저가 마이크를 사용할 수 있는지 확인하세요.',
    'microphoneQuality.title': '마이크 품질',
    'microphoneQuality.instructions': '몇 초간 말씀해 주시면 음성이 얼마나 잘 들리는지 확인해 드릴 수 있습니다.',
    'microphoneQuality.recoveryMessage': '목소리가 들리지 않습니다. 통화 중이라면 먼저 통화를 종료해 주세요. 마이크를 사용하는 다른 앱을 닫은 후 다시 시도해 주세요.',
    'microphoneQuality.poor': '나쁨',
    'microphoneQuality.almostThere': '거의 다 됐어요',
    'microphoneQuality.perfect': '완벽합니다!',
    'microphoneQuality.waiting': '오디오 대기 중...',
    'microphoneQuality.from': '출처',
    'microphoneQuality.defaultDevice': '기본 마이크',
    'microphoneQuality.helpText': '더 크게 말씀하시거나 마이크에 더 가까이 다가가 주세요',
    'microphoneQuality.done': '완료',
    'startupRecovery.title': '대화를 시작하지 못했습니다',
    'startupRecovery.failed': '대화 서비스에 연결하지 못했습니다. 다시 시도해 주세요.',
    'startupRecovery.timedOut': '연결에 너무 오래 걸렸습니다. 다시 시도해 주세요.',
    'startupRecovery.cancelled': '연결이 취소되었습니다. 준비되면 다시 시도할 수 있습니다.',
    'startupRecovery.microphone': '마이크에 접근할 수 없습니다. 권한을 확인하고 다시 시도해 주세요.',
    'startupRecovery.delayed': '연결 중입니다. 평소보다 오래 걸리고 있습니다…',
    'startupRecovery.retry': '다시 시도',
    'startupRecovery.support': '지원 문의 참조 번호',
    'startupRecovery.copy': '참조 번호 복사',
    'startupRecovery.copied': '복사됨',
    'startupRecovery.checking': '연결 확인 중…',
    'startupRecovery.unavailable': '확인할 수 없음',
    'startupRecovery.advice': '이 검사는 서비스 접속 가능 여부만 확인합니다. 그래도 시작을 시도할 수 있습니다. 실패하면 다른 브라우저나 네트워크를 사용해 보세요.',
    'startupRecovery.checkAgain': '연결 다시 확인...',
    'connectionDetails.quality': '네트워크 품질',
    'connectionDetails.excellent': '매우 좋음',
    'connectionDetails.good': '좋음',
    'connectionDetails.poor': '약함',
    'connectionDetails.bad': '나쁨',
    'connectionDetails.offline': '오프라인',
    'connectionDetails.notChecked': '확인하지 않음',
    'connectionDetails.lastChecked': '마지막 확인',
    'connectionDetails.warning': '{{services}} 연결을 확인할 수 없습니다.',
    'connectionDetails.navaApi': 'Clair API',
    'connectionDetails.interviewApi': 'Clair 대화 서비스',
    'connectionDetails.ok': 'OK',
    'connectionDetails.refresh': '연결 테스트 새로고침',
    'connectionDetails.success': '연결 확인에 성공했습니다.',
    'connection.error': '연결 오류',
    'connection.errorDefault': '대화 서비스에 연결하지 못했습니다',
    'connection.retry': '다시 시도',
    'versionRefresh.message': '새 버전이 사용 가능합니다. 준비되시면 브라우저를 새로 고쳐 주세요.',
    'versionRefresh.action': '새로 고침',
    'cookies.banner.title': '개인정보를 소중하게 생각합니다',
    'cookies.banner.message': '최적의 경험 제공, 제품 사용 이해, 관련 마케팅 지원을 위해 쿠키를 사용합니다. <bold>“모두 수락”</bold>을 선택하여 모든 쿠키에 동의하거나, <bold>“환경설정 관리”</bold>를 선택하여 설정을 조정하세요.',
    'cookies.banner.privacyPolicy': '개인정보 처리방침',
    'cookies.banner.acceptAll': '모두 수락',
    'cookies.banner.managePreferences': '환경설정 관리',
    'cookies.modal.title': '쿠키 설정',
    'cookies.modal.description': 'Clair를 방문하시면 쿠키 및 유사한 기술을 사용해 귀하에 관한 데이터를 저장하거나 불러올 수 있습니다. 필수 쿠키는 웹사이트가 작동하도록 합니다. 선택 항목 설정은 언제든지 변경할 수 있습니다.',
    'cookies.modal.readMore': '자세히 보기:',
    'cookies.modal.save': '저장',
    'cookies.modal.close': '쿠키 환경설정 닫기',
    'cookies.modal.essential.title': '필수',
    'cookies.modal.essential.description': '기본 웹사이트 기능에 필요합니다. 필수 쿠키는 비활성화할 수 없습니다.',
    'cookies.modal.analytics.title': '분석',
    'cookies.modal.analytics.description': 'Clair가 웹사이트의 작동 방식, 방문자의 이용 방식, 기술적 문제 여부를 파악하는 데 도움이 됩니다.',
    'invitation.subject': '{company}와의 짧은 대화',
    'invitation.greeting': '{name}님, 안녕하세요.',
    'invitation.body': '요즘 어떠신지 듣고 싶습니다.',
    'invitation.aiNotice': '저희 AI 어시스턴트 Clair와 대화하시게 됩니다. 대부분의 사람들은 사람보다 AI에게 더 솔직하게 말하기 쉽다고 느끼며, 직장에서든 집에서든 편하신 때에 하시면 됩니다.',
    'invitation.button': '대화 시작하기',
    'invitation.fallbackLink': '또는 이 링크를 브라우저에 붙여넣으세요:',
    'invitation.footer': '{company}의 고객이시기 때문에 이 메일을 받으셨습니다. 대화는 {company}의 의뢰로 AI 어시스턴트 Clair가 진행합니다.',
    'invitation.optOut': '이런 메일 그만 받기',
    'sms.invite': '{company}에서 짧은 대화에 초대합니다:',
    'sms.stop': '문자 수신 거부:',
};
//# sourceMappingURL=ko.js.map